import { Observable } from 'rxjs';
import { CountDestinationsResponse } from '../models/count-destinations.model';

export abstract class CountDestinationsRepository {
    abstract getCountDestinations(): Observable<CountDestinationsResponse>;
}
